import React from "react";
import {TextField} from "@mui/material";
import {useTranslation} from "react-i18next";
import CNumberField from "crqlar-react-common/dist/components/CNumberField";
import {
    clampPrintoutQrCodeSizeMm,
    getPrintoutQrCodeAttrs,
    MAX_PRINTOUT_QR_CODE_SIZE_MM,
    MIN_PRINTOUT_QR_CODE_SIZE_MM,
} from "../../../blocks/qrCode/printoutQrCodeOptions";
import type {PrintoutQrCodeNodeAttrs} from "../../../blocks/qrCode/printoutQrCodeOptions";
import {PanelField} from "../PrintoutPanelSection";
import {updateSelectedPrintoutBlockAttributes} from "./printoutBlockAttributes";
import type {PrintoutBlockSettingsProps} from "./printoutBlockAttributes";

export function QrCodeSettings({block, disabled, editor}: PrintoutBlockSettingsProps) {
    const {t} = useTranslation();

    const attrs = getPrintoutQrCodeAttrs(block.node.attrs as PrintoutQrCodeNodeAttrs);

    const update = (next: Record<string, unknown>) =>
        updateSelectedPrintoutBlockAttributes(editor, block, next);

    return (
        <>
            <PanelField label={t('URL')}>
                <TextField
                    disabled={disabled}
                    fullWidth
                    onChange={(event) => update({url: event.target.value || null})}
                    placeholder={'https://'}
                    size={'small'}
                    type={'url'}
                    value={attrs.url ?? ''}
                />
            </PanelField>

            <PanelField label={t('Size mm')}>
                <CNumberField
                    disabled={disabled}
                    fullWidth
                    max={MAX_PRINTOUT_QR_CODE_SIZE_MM}
                    min={MIN_PRINTOUT_QR_CODE_SIZE_MM}
                    onChange={(next) => {
                        if (next !== null) update({sizeMm: clampPrintoutQrCodeSizeMm(next)});
                    }}
                    size={'small'}
                    step={1}
                    value={attrs.sizeMm}
                />
            </PanelField>
        </>
    );
}

export default QrCodeSettings;
